export default "__VITE_ASSET__BMHAPSmZ__"